import type { CustomerSafeTicket } from "@msc/shared";

/**
 * Führt die bekannten Tickets EINER laufenden Präsentation fort: Was einmal
 * im Deck lag, bleibt bekannt, auch wenn es aus der Ticketliste verschwindet.
 *
 * Der Grund liegt in der Abfrage hinter der Liste (`buildTicketsJql` in
 * `apps/api/src/modules/customer-view/jsm.service.ts`): Sie führt alles
 * außerhalb der Kategorie „Done“ plus kürzlich „Erledigt“. Wer im Termin einen
 * Vorgang auf einen anderen Done-Status setzt (etwa „Geschlossen“), verliert
 * ihn beim verzögerten Neuladen nach `JIRA_INDEX_LAG_MS` aus der Liste — und
 * die Folie beim Kunden wäre mitten im Satz leer. Deshalb wird hier nur
 * ergänzt und aktualisiert, nie entfernt.
 *
 * Rein: `prev` bleibt unberührt, zurück kommt eine neue Map.
 */
export function mergeKnownTickets(
  prev: Map<string, CustomerSafeTicket>,
  next: CustomerSafeTicket[],
): Map<string, CustomerSafeTicket> {
  const merged = new Map(prev);
  for (const ticket of next) merged.set(ticket.key, ticket);
  return merged;
}
